class CartDrawer extends SlidingDrawer {
  constructor() {
    super();
    this.overlayElement = this.querySelector(".js-cart-overlay");
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.closeDrawer()
    );

    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.closeDrawer.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.openCartOnUrlParams();
  }
  openCartOnUrlParams() {
    if (!window.URLSearchParams) {
      console.warn("does not work in IE11");
      return;
    }

    const searchParams = new window.URLSearchParams(window.location.search);

    if (searchParams.get("cart") === "open") {
      this.openDrawer();
    }
  }
  setHeaderCartIconAccessibility() {
    // const cartLink = document.querySelector("#cart-icon");
    // cartLink.setAttribute("role", "button");
    // cartLink.setAttribute("aria-haspopup", "dialog");
    // cartLink.addEventListener("keydown", (event) => {
    //   if (event.code.toUpperCase() === "SPACE") {
    //     event.preventDefault();
    //     this.open(cartLink);
    //   }
    // });
  }
  bindEvents() {
    document.querySelector(".js-cart-drawer-toggle").addEventListener(
      "click",
      this.onDrawerToggleClick.bind(this)
    );
  }

  openDrawer() {
    setTimeout(() => {
      this.drawerToggle.classList.add("drawer-opening");
    });
    this.drawerToggle.setAttribute("aria-expanded", true);
    this.drawerElement.removeAttribute('inert');
    this.setAttribute("data-open", "");
    this.drawerElement.classList.add("drawer--open");
    this.overlayElement.classList.add("drawer--open");

      // Enable tabbing only on elements inside the drawer
      enableTabbing(this.drawerElement);

    // Apply focus trap
    trapFocus(this.drawerElement);
    document.body.classList.add("overflow-hidden");
  }

  closeDrawer() {
    this.drawerElement.classList.remove("drawer--open");
    this.overlayElement.classList.remove("drawer--open");
    this.drawerToggle.classList.remove("drawer-opening");
    this.drawerToggle.setAttribute("aria-expanded", false);
    this.drawerElement.setAttribute('inert', '');
    document.body.classList.remove('overflow-hidden');

      // Disable tabbing on elements inside the drawer
    disableTabbing(this.drawerElement);

    // remove trap focus
    removeTrapFocus(this.activeElement);

    this.closeAnimation();
  }

  onFocusOut() {}

  renderContents(parsedState) {
    this.querySelector(".js-cart-drawer-inner").classList.contains(
      "is-empty"
    ) &&
      this.querySelector(".js-cart-drawer-inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.closeDrawer.bind(this)
      );
      this.openDrawer();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".js-cart-drawer-inner",
      },
      {
        id: "cart-icon",
        section: "cart-icon",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);


//custom Mod Bundles add to cart
document.addEventListener("cart:updated", async (event) => {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  const sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
  const sectionsUrl = window.location.pathname;

  try {
    const response = await fetch("/?sections=" + sectionsToRender.join(","), {
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    const data = await response.json();

    // Re-render cart drawer contents
    cartDrawer.renderContents({
      id: 'cart',
      sections: data,
      sectionsUrl: sectionsUrl
    });

    // Poll for the button to reappear and click it
    const openDrawerWhenReady = () => {
      const trigger = document.querySelector('[aria-controls="CartDrawer"]');
      if (trigger) {
        trigger.click();
      } else {
        requestAnimationFrame(openDrawerWhenReady);
      }
    };

    openDrawerWhenReady();

  } catch (err) {
    console.error("Cart drawer update + open failed:", err);
  }
});